// extracted by mini-css-extract-plugin
export default {"round":"Checkbox_round__7dHSC","container":"Checkbox_container__2zScV"};